// frontend/packs/search.js

/* eslint-disable import/first, import/newline-after-import */

import '../layouts/page/search-page.css';

import { Application } from 'stimulus';
export const search = Application.start(); // eslint-disable-line import/prefer-default-export

import 'components/resources/grid/grid';

import 'components/util/tags-carousel/tags-carousel';
import 'components/search/search-filters/search-filters';
import 'components/search/search-results/search-results';

import 'components/global/promos/promo-popup';

import ResourcesGridController from '../components/resources/grid/grid-controller';
search.register('resources-grid', ResourcesGridController);

import EzCarouselController from '../components/util/ez-carousel/ez-carousel-controller';
search.register('ez-carousel', EzCarouselController);

import SearchFiltersController from '../components/search/search-filters/search-filters-controller';
search.register('search-filters', SearchFiltersController);

import NumPagerController from '../components/util/num-pager/num-pager-controller';
search.register('ez-num-pager', NumPagerController);

import ShutterstockPopupController from '../controllers/shutterstock/popup-controller';
search.register('shutterstock-popup', ShutterstockPopupController);

import SSTKSponsoredSearchController from '../components/sstk/search/sponsored-results/sponsored-results-controller';
search.register('sstk-sponsored-search', SSTKSponsoredSearchController);

import SSTKJustifiedSearchController from '../components/sstk/search/justified-search/sstk-justified-search-controller';
search.register('sstk-justified-search', SSTKJustifiedSearchController);

import PromoPopupController from '../components/global/promos/promo-popup-controller';
search.register('promo-popup', PromoPopupController);
